
import React from "react";
import {withTranslation} from "react-i18next";

class NotFound extends React.Component {
    render() {
        return(
            <div className="account-pages my-5 pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="mt-4 text-center">
                                <h1 className="mt-5 text-uppercase text-dark font-weight-bold mb-3" >Error</h1>
                                <h5 className="text-dark">Ha ocurrido un error de conexión con el sistema. Nuestro equipo ha sido notificado y trabajará para solucionarlo lo antes posible. Por favor, intenta nuevamente en unos minutos. Gracias por tu paciencia.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(NotFound);